import { Box, Group, Pagination, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { LIST_PAGE_SIZE, pageCount } from '../utils/list';

type Props = {
    page: number;
    totalItems: number;
    onChange: (page: number) => void;
    pageSize?: number;
};

/** Sticky to the bottom of the viewport while the list scrolls. */
export const ListPagination = ({
    page,
    totalItems,
    onChange,
    pageSize = LIST_PAGE_SIZE,
}: Props) => {
    const { t } = useTranslation();
    const total = pageCount(totalItems, pageSize);
    if (totalItems <= pageSize) return null;

    const from = (page - 1) * pageSize + 1;
    const to = Math.min(page * pageSize, totalItems);

    return (
        <Box
            pos='sticky'
            bottom={0}
            mt='auto'
            py='sm'
            px='md'
            style={{
                zIndex: 20,
                marginLeft: 'calc(-1 * var(--mantine-spacing-lg))',
                marginRight: 'calc(-1 * var(--mantine-spacing-lg))',
                paddingLeft: 'var(--mantine-spacing-lg)',
                paddingRight: 'var(--mantine-spacing-lg)',
                background: 'color-mix(in srgb, var(--mantine-color-body) 88%, transparent)',
                backdropFilter: 'blur(10px)',
                borderTop: '1px solid var(--mantine-color-gray-3)',
                boxShadow: '0 -6px 16px rgba(15, 23, 42, 0.04)',
            }}
        >
            <Group justify='space-between' wrap='wrap' gap='sm'>
                <Text size='sm' c='dimmed'>
                    {t('pagination.range', { from, to, total: totalItems })}
                </Text>
                <Pagination value={page} onChange={onChange} total={total} />
            </Group>
        </Box>
    );
};
